import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogInPageComponent } from './page/log-in-page/log-in-page.component';
import { OtpLogInPageComponent } from './page/otp-log-in-page/otp-log-in-page.component';
import { TotpVerifyComponent } from './page/totp-verify/totp-verify.component';


const routes: Routes = [
  {
    path: '',
    component :LogInPageComponent
  },
  {
    path: 'otp',
    component: OtpLogInPageComponent
  },
  {
    path: 'totp-verify',
    component: TotpVerifyComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
